// Supabase klient — ten istý projekt ako Lumio (lummio.app)
import { createClient } from "@supabase/supabase-js";

export const SB_URL = "https://bflqqeiwvofbafpmsbcb.supabase.co";
export const SB_ANON =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJmbHFxZWl3dm9mYmFmcG1zYmNiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzg5NTk0NDIsImV4cCI6MjA5NDUzNTQ0Mn0.Pu9XZUeRoZYJIIZnQfNrukEK1iqLjcRgEgPbX0QGRPA";

export const sb = createClient(SB_URL, SB_ANON, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    storageKey: "dash_auth", // oddelené od Lumio session storageKey
  },
});
